import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Curse extends Bloc {

	constructor (src, ctx) {

		super("curse", src, ctx, true);
		this.f = (src, ins) => {
			src.master.run.champion.applyCurse(ins[0]);
			return [];
		};
		this.types = [Types.string];
	}
}
